/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { O5AwsDeployerV1ClusterQueryServiceClusterGetClusterGetRequest, O5AwsDeployerV1ClusterQueryServiceClusterGetResponse } from '@interxfi/types';

export const O5_AWS_DEPLOYER_V1_CLUSTER_QUERY_SERVICE_CLUSTER_GET_AUDIENCE = ['o5'];

export async function o5AwsDeployerV1ClusterQueryServiceClusterGet(baseUrl: string | undefined, request?: O5AwsDeployerV1ClusterQueryServiceClusterGetClusterGetRequest, requestInit?: RequestInit): Promise<O5AwsDeployerV1ClusterQueryServiceClusterGetResponse | undefined> { return makeRequest<O5AwsDeployerV1ClusterQueryServiceClusterGetResponse, O5AwsDeployerV1ClusterQueryServiceClusterGetClusterGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/deployer/v1/clusters/q/:clusterId', request, requestInit)); }

